import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import TimeField from './timeField'
import NumberField from '../fields/numberField'
import { GraphDataParam } from '../../types/enums/graphDataParam'
import { getGraphLimits, getValueSuffix } from '../../utils/graphUtils'
import { SeriesType } from '../../types/enums/seriesType'

interface GraphPointEditorProps {
  time: number
  numValue: number
  minX: number
  maxX: number
  editParam: GraphDataParam
  valueSuffix: string
  isXaxisTemp: boolean
  isFirstPoint?: boolean
  editProp?: 'time' | 'value' | ''
  onSubmit: (newTime: number, newValue: number) => void
  onCancel: () => void
}

const GraphPointEditor = (props: GraphPointEditorProps): JSX.Element => {
  const { t } = useTranslation()

  const [timeValue, setTimeValue] = React.useState<number>(props.time)
  const [numValue, setNumValue] = React.useState<number>(props.numValue)

  return (
    <>
      <TableRow>
        <TableCell sx={{ p: 0 }}>
          {props.isXaxisTemp && props.isFirstPoint && <div style={{ marginLeft: 8 }}>{t('editprofileview.start')}</div>}
          {props.isXaxisTemp && !props.isFirstPoint && (
            <NumberField
              isSmall
              valueSuffix={getValueSuffix(SeriesType.TEMPERATURE)}
              numValue={props.time}
              disabled={props.isFirstPoint}
              minNumValue={props.minX}
              maxNumValue={props.maxX}
              label=""
              autoFocus={props.editProp === 'time'}
              onBlur={(newValue: number) => setTimeValue(newValue)}
              onEnter={(newValue: number) => props.onSubmit(newValue, numValue)}
            />
          )}
          {!props.isXaxisTemp && (
            <TimeField
              timeValue={props.time}
              disabled={props.isFirstPoint}
              minValue={props.minX}
              maxValue={props.maxX}
              label=""
              autoFocus={props.editProp === 'time'}
              onBlur={(newValue: number) => setTimeValue(newValue)}
              onEnter={(newValue: number) => props.onSubmit(newValue, numValue)}
            />
          )}
        </TableCell>
        <TableCell sx={{ p: 0 }} colSpan={2}>
          <NumberField
            isSmall
            valueSuffix={props.valueSuffix}
            numValue={numValue || ''}
            minNumValue={getGraphLimits(props.editParam).min}
            maxNumValue={getGraphLimits(props.editParam).max}
            onBlur={setNumValue}
            autoFocus={props.editProp === 'value'}
            onEnter={(newValue: number) => props.onSubmit(timeValue, newValue)}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell sx={{ p: 0 }} colSpan={3}>
          <Button onClick={() => props.onSubmit(timeValue, numValue)}>{t('common.ok')}</Button>
          <Button onClick={props.onCancel}>{t('common.cancel')}</Button>
        </TableCell>
      </TableRow>
    </>
  )
}

export default GraphPointEditor
